import React from "react";

import { AttributeCardDisplayVariantType } from "../types";

import AttributeSelectionCard from "@/Components/PersonalAttributes/Components/AttributeSelectionCard";
import { type AppUserSession } from "@/schemas/auth/session";
import {
  BodyType,
  UserBodyAttributeSet,
} from "@/schemas/profile/attributes/UserBodyAttributeSet";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type BodyProps = {
  session: AppUserSession;
  bodyValue: BodyType | null;
  variant: AttributeCardDisplayVariantType;
};

function BodySelection({
  session,
  bodyValue,
  variant,
}: BodyProps): React.JSX.Element {
  const values = bodyValue ? [UserBodyAttributeSet.map[bodyValue]] : [];
  const typedValues = values.filter(
    (item): item is AttributeValue => item !== undefined,
  );

  return (
    <AttributeSelectionCard
      session={session}
      attribute={UserBodyAttributeSet}
      values={typedValues}
      icon={"🏋️‍♀️"}
      variant={variant}
    />
  );
}

export default BodySelection;
